<template>
    <div>
        <div class="header">
            <a href="/">
                <img src="../../images/header-logo.png" alt="Logo" class="logo">
            </a>
        </div>
        <div class="dataspace-layout">
            <div class="dataspace-sidebar">
                <div class="sidebar-header">
                    <RouterLink to="/dataspaces" class="sidebar-back">
                        <i class="fas fa-arrow-left"></i>
                    </RouterLink>
                    <span class="sidebar-title">{{ dataSpaceName }}</span>
                </div>
                <nav class="sidebar-nav">
                    <RouterLink :to="`/dataspace/${dataSpaceId}/tables`" :class="['sidebar-link', isActive('tables')]">
                        <i class="fas fa-table"></i>
                        <span>{{ $t('tables') }}</span>
                    </RouterLink>
                    <RouterLink :to="`/dataspace/${dataSpaceId}/batches`" :class="['sidebar-link', isActive('batches')]">
                        <i class="fas fa-cogs"></i>
                        <span>{{ $t('batches') }}</span>
                    </RouterLink>
                </nav>
            </div>
            <div class="dataspace-content">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
import DataSpaceApi from "../../api/server/dataspace";

export default {
    name: "DataSpaceLayout",
    computed: {
        dataSpaceId() {
            return this.$route.params.id;
        }
    },
    watch: {
        dataSpaceId: {
            immediate: true,
            handler(newId) {
                if (newId) this.loadDataSpace(newId);
            }
        }
    },
    methods: {
        async loadDataSpace(id) {
            var ds = await DataSpaceApi.dataSpaceDetail(id);
            this.dataSpaceName = ds.name ?? "";
        },
        isActive(section) {
            var path = this.$route.path;
            if (section === 'tables') {
                return path.includes('/tables') ? 'active' : '';
            }
            if (section === 'batches') {
                return path.includes('/batches') ? 'active' : '';
            }
            return '';
        }
    },
    data() {
        return {
            dataSpaceName: ""
        };
    }
};
</script>